// eslint-disable-next-line import/no-extraneous-dependencies
import gql from 'graphql-tag';

const imageObj = `{
  inputTemplate
  viewMode
  imageUrlLinkGroup
  imageUrlLinkGroupTarget
  accessibility
  title
  credit
  aspects
  isAnimatedGif
  contentId
  imgArray {
    imgName
    aspects
  }
  imageType
  kind
  contentName
}`;

export const authorImage = gql`
    fragment AuthorImage on Author {
      image ${imageObj}
    }
  `;
export const clicktrackerImage = gql`
    fragment ClickTrackerImage on ClickTrackerBanner {
      clicktrackerimage ${imageObj}
    }
  `;
export const imagesInTeaser = gql`
    fragment ImagesInTeaser on Teaser {
      image ${imageObj}
      authorImage ${imageObj}
    }
  `;

export const imageInTeaser = gql`
    fragment ImageInTeaser on Teaser {
      image ${imageObj}
    }
  `;
export const headlineImage = gql`
  fragment HeadlineImage on HeaderData {
    image ${imageObj}
  }
`;
export const seoImage = gql`
  fragment SeoImage on SeoData {
    ogImage ${imageObj}
  }
`;
export const quoteImage = gql`
  fragment QuoteImage on Quote {
    imagesList ${imageObj}
  }
`;

export default gql`
  fragment Image on Image
    ${imageObj}
`;
